<template>
    <div
        ref="container"
        :class="['the-grid-overlay container p-0 pointer-events-none', { hidden: !visible }]"
    >
        <!-- TODO: update when changing containers global small padding and move all classes into one element & remove the padding -->
        <div
            class="fixed top-0 bottom-0 container z-70"
            :style="{ width }"
        >
            <div class="h-full grid grid-default opacity-10">
                <div
                    v-for="num in 12"
                    :key="num"
                    :class="[
                        'bg-red-400',
                        {
                            hidden: num > 4,
                            'md:block': num <= 8,
                            'lg:block': num > 8,
                        },
                    ]"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import { storage } from '@helpers/storage';

const STORAGE_KEY = 'gridOverlayEnabled';

/**
 * Global grid overlay for a page based on our design specs.
 * Toggable with "Ctrl+G" or "Ctrl+Shift+4"
 */
export default {
    name: 'TheGridOverlay',
    data: () => ({
        width: 0,
        visible: storage.getItem(STORAGE_KEY) === 'true' || false,
    }),
    created() {
        window.addEventListener('resize', this.adjustSize);
        window.addEventListener('keydown', this.onKeyDown);
    },
    mounted() {
        this.adjustSize();
        this.visible = storage.getItem(STORAGE_KEY) === 'true' || false;
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.adjustSize);
        window.removeEventListener('keydown', this.onKeyDown);
    },
    methods: {
        adjustSize() {
            this.width = `${this.$refs.container.offsetWidth}px`;
        },
        onKeyDown(e) {
            if ((e.ctrlKey && e.shiftKey && e.code === 'Digit4') || (e.ctrlKey && e.key === 'g')) {
                this.visible = !this.visible;
                storage.setItem(STORAGE_KEY, this.visible);
                e.preventDefault();
            }
        },
    },
};
</script>
